<div class="content-heading">
  <div class="header-container">
    <h3>Vehículos de Logística Secundaria</h3>
    <small>Catálogo y gestión de unidades por centro de venta</small>
  </div>
</div>

<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-default">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-xs-12">

              <div class="row filter-container d-flex align-items-end mb-2">
                <div class="col-md-5">
                  <label class="text-bold">Centro de Venta (CEVE)</label>
                  <div class="ng-autocomplete">
                    <ng-autocomplete placeholder="Buscar centro de venta..." [data]="ceveList" [searchKeyword]="keyword"
                      (selected)='selectEvent($event)' (inputCleared)="cmbOutputCeve()" [itemTemplate]="itemTemplate"
                      [notFoundTemplate]="notFoundTemplate" [(ngModel)]="selectedUnit">
                    </ng-autocomplete>

                    <ng-template #itemTemplate let-item>
                      <a [innerHTML]="item.CeveName"></a>
                    </ng-template>

                    <ng-template #notFoundTemplate let-notFound>
                      <div [innerHTML]="'No se encontraron coincidencias'"></div>
                    </ng-template>
                  </div>
                </div>
                <div class="ml-auto mr-3">
                  <aph-custom-buttons type="button" preset="refresh" (btnClick)="refresh()"
                    style="margin-bottom: -8px;"></aph-custom-buttons>
                </div>
              </div>
              <div class="row">
                <app-ceq-table class="col-12" #CeqGrid [gridAdditionalOptions]="gridOptions" [columnDef]="columnDefs"
                  (apiEmitter)="gridEmiter($event)">
                </app-ceq-table>
              </div>
            </div>
            <div class="col-md-12 col-xs-12 mt-3">
              <aph-custom-buttons preset="add" label="Nuevo vehículo" (btnClick)="btnAddClick()">
              </aph-custom-buttons>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>